import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiParameters } from 'src/app/configs/api.params';
import { IWorker } from '../models/worker.model';

@Injectable({
  providedIn: 'root',
})
export class WorkerService {
  constructor(private http: HttpClient) {}

  getCompanyWorkers(companyId: string): Observable<IWorker> {
    return this.http.get<IWorker>(
      `${apiParameters.url}/companies/${companyId}/workers`
    );
  }

  createCompanyWorker(companyId: string, body: any): Observable<IWorker> {
    return this.http.post<IWorker>(
      `${apiParameters.url}/companies/${companyId}/workers`,
      body
    );
  }

  deleteCompanyWorker(companyId: string, workerId: string): Observable<any> {
    return this.http.delete(
      `${apiParameters.url}/companies/${companyId}/workers/${workerId}`
    );
  }

  getCompanyWorker(companyId: string, workerId: string): Observable<IWorker> {
    return this.http.get<IWorker>(
      `${apiParameters.url}/companies/${companyId}/workers/${workerId}`
    );
  }

  updateCompanyWorker(
    companyId: string,
    workerId: string,
    body: any
  ): Observable<IWorker> {
    return this.http.patch<IWorker>(
      `${apiParameters.url}/companies/${companyId}/workers/${workerId}`,
      body
    );
  }

  getWorkerAssignedInventars(workerId: string): Observable<IWorker> {
    return this.http.get<IWorker>(
      `${apiParameters.url}/workers/${workerId}/inventars`
    );
  }
}
